import { bsToAd } from "@sbmdkl/nepali-date-converter";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import { InputMask } from "primereact/inputmask";
import React, { useEffect, useState } from "react";

const NepaliDatePicker2 = (props) => {
  const [date, setDate] = useState();
  const [finalDate, setFinalDate] = useState();
  const [show, setShow] = useState(false);

  useEffect(function () {
    setDate(props.value);
  }, [props.value]);


  const handleNepaliDateChange = (date) => {
    try {
      // const adDate = bsToAd(date);
      setDate(date);
      setFinalDate(date);
      props.onChange(date);
      console.log("NepaliDatePicker date change (BS):", date);
    } catch (error) {
      console.error("Invalid Nepali date:", date);
    }
  };



  return (
    <div style={{ flexDirection: "row", flex: 1, }}>
      {/* <h1>{JSON.stringify(date)}</h1> */}
      <InputMask
        class={
          props.inputClassName
        }
        style={{

          width: "100%"
        }}
        placeholder={props.placeholder}
        mask="9999-99-99"
        value={date}
        onChange={(e) => {
          setDate(e.target.value)
        }}

        onComplete={(e) => {
          if (!isNaN(new Date(e.value).getTime())) {
            try {
              bsToAd(e.value);//important to check convertable date of not.
              setFinalDate(e.value);
              props.onChange(e.value); // Change the date from bs to ad by typing .
            } catch (error) {
              console.log("Not a valid date.");
            }
          }
        }}
        onFocus={(e) => {
          // setShow(Math.random());
        }}
        onBlur={(e) => {

          // setShow(false);

        }}
        disabled={props.disabled}
      />

      <NepaliDatePicker
        {...props}
        value={finalDate}
        onChange={handleNepaliDateChange}
        show={props.show}

      />

    </div>
  );
};

export default NepaliDatePicker2;
